import React from 'react';
import styles from './Overview.module.less';
import classNames from 'classnames';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';

const selectForum = createSelector(
  state => state.forum,
  forum => forum,
);
export default ({ specialInfo = {}, zan, handel }) => {
  const { forumCommentList: commentList } = useSelector(selectForum);
  const handleSkip = () => {
    if (handel.comment) {
      handel.comment.scrollIntoView({ block: 'center' });
    }
  };
  const handleNumber = (data = 0) => {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(+data)) {
      return data;
    }
    if (+data < 1000) {
      return data > 0 ? data : 0;
    }
    if (+data < 10000) {
      return `${(data / 1000).toFixed(1)}k`;
    }

    return `${(data / 10000).toFixed(1)}w`;
  };
  return (
    <div className={styles.overview}>
      <div
        className={classNames(styles.overview_item, specialInfo.hasCollect && styles.active)}
        onClick={handel.collect}
      >
        <i
          className={classNames(
            'iconfont',
            specialInfo.hasCollect ? 'icon-collected' : 'icon-collect',
          )}
        ></i>
        <span>{handleNumber(specialInfo.collectCount)}</span>
      </div>
      <div
        className={classNames(styles.overview_item, (specialInfo.hasZan || zan) && styles.active)}
        onClick={handel.zan}
      >
        <i
          className={classNames('iconfont', specialInfo.hasZan || zan ? 'icon-zaned' : 'icon-zan')}
        ></i>
        <span>{handleNumber(specialInfo.zanCount)}</span>
      </div>
      <div className={styles.overview_item} onClick={handleSkip}>
        <i className={classNames('iconfont', 'icon-comment')}></i>
        <span>
          {handleNumber(
            (commentList &&
              commentList.dataList &&
              commentList.dataList[0] &&
              commentList.dataList[0].comment &&
              commentList.dataList[0].comment.bizIdentity === specialInfo.ztCommentId &&
              commentList.totalCount) ||
              0,
          )}
        </span>
      </div>
    </div>
  );
};
